import React from 'react';
import { NextPage } from 'next';
import dynamic from 'next/dynamic';
import { ICurrentCity } from '~/src/store/reducers/city';
import { initialProps } from '~/src/helpers/basePageFunc';
import Layout from '~/src/layout/_layout';
import { getAvailability } from '~/src/api/loyalty/program/availability';
import { getInfo, IInfoData } from '~/src/api/loyalty/program/info';
import { selectDomain } from '~/src/store/selectors/domain';
import { TState } from '~/src/store';

const NewPayments = dynamic(() => import('~/src/layout/newPayments'));


interface IProps {
    hostname: string,
    currentCity: ICurrentCity,
    loyaltyIsRegistered: boolean,
    loyaltyInfo: IInfoData | undefined,
}

const NewPaymentsPage: NextPage<IProps> = ({ hostname, currentCity, loyaltyIsRegistered, loyaltyInfo }) => {
    return (
        <Layout
            // @ts-ignore
            title={`Оплата услуг Дом.ру банковской картой онлайн | Заплатить за интернет, ТВ, телефон в ${currentCity.cityIn}`}
            description={`Оплата услуг провайдера Дом.ру в ${currentCity.cityIn} без комиссии. Выберите любой удобный способ онлайн оплаты интернета, телевидения и телефонии или подключите услугу "Автоплатеж". Подробнее на сайте`}
            hostname={hostname}
            withMenu={true}
            withChat={true}
            withFooter={true}
            relCanonical={`https://${hostname}/payments`}
        >
            <>
                <NewPayments
                    loyaltyIsRegistered={loyaltyIsRegistered}
                    loyaltyInfo={loyaltyInfo}
                />
            </>
        </Layout>
    );
};

NewPaymentsPage.getInitialProps = async(options) => {
    const { hostname, store: { getState } } = await initialProps(options);
    const state: TState = getState();
    const { city: { currentCity }, auth: { accessToken } } = state;

    const domain = selectDomain(state);

    const loyaltyAvailableResp = await getAvailability({ domain, accessToken });
    const loyaltyIsRegistered = loyaltyAvailableResp.isSuccess && loyaltyAvailableResp?.payload?.isRegistered;

    const infoResp = loyaltyIsRegistered
        ? await getInfo({ domain, accessToken })
        : { isSuccess: false, payload: undefined };

    return { hostname, currentCity, loyaltyIsRegistered, loyaltyInfo: infoResp.isSuccess ? infoResp.payload : undefined };
};

export default NewPaymentsPage;
